import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { Payment } from '../../waitingnotes.component';

export interface PaymentHistoryDialog {
    payments: {
        captured: string;
        TIPS: number;
        total: number;
        type_payment: number;
        id_payment_mean: number;
    }[];
    totalAmount: number;
    decimalsString: string;
    currencySymbol: string;
}

@Component({
    selector: 'app-payment-history-dialog',
    templateUrl: './payment-history-dialog.component.html',
    styleUrls: ['./payment-history-dialog.component.css']
})
export class PaymentHistoryDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<PaymentHistoryDialogComponent>,
        public cssService: CssService,
        public paymentService: PaymentService,
        @Inject(MAT_DIALOG_DATA) public data: {
            currencySymbol: string;
            decimalString: string;
            payments: Payment[];
            totalAmount: number;
        }
    ) { }


    isClosing = false;
    selectedOption: string | null = null;
    paymentMeanLabel = '';
    paymentMeanLabelMap: Record<number, string> = {};

    ngOnInit(): void {
        const uniqueIds = Array.from(new Set(this.data.payments.map(p => p['id_payment_mean'])));
        uniqueIds.forEach(id => {
            this.loadPaymentMeanLabel(id);
        });
    }

    paymentType(type_payment: number) {
        switch (type_payment) {
            case (0):
                return ("en caisse");
            case (1):
                return ("total");
            case (2):
                return ("paiement libre");
            case (3):
                return ("paiement par article");
        }
        return ("error");
    }

    async loadPaymentMeanLabel(id_payment_mean: number) {
        if (this.paymentMeanLabelMap[id_payment_mean]) return;

        const result = await this.paymentService.getPaymentMean(id_payment_mean);
        if (result) {
            this.paymentMeanLabelMap[id_payment_mean] =
                this.capitalizeFirstLowerRest(result.N_PAYMENT_MEAN);
        } else {
            this.paymentMeanLabelMap[id_payment_mean] = 'Inconnu';
        }
    }

    capitalizeFirstLowerRest(text: string): string {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    onCancel() {
        this.selectedOption = null;
        this.isClosing = true;
    }

    onAnimationEnd() {
        if (this.isClosing)
            this.dialogRef.close(this.selectedOption);
    }
}
